import React from 'react'
import Helmet from 'react-helmet'

import '../style/style.css';

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="React Academy Slides"
      meta={[
        { name: 'description', content: 'React Academy Slides' },
        { name: 'keywords', content: 'react academy, slides' },
      ]}
    />
    <div>
      {children()}
    </div>
  </div>
)

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js